const Joi = require('joi');

const FormConfig = module.exports = {
    formId: 'survey-solve-form',

    rerenderDeps(props = {}) {

        return [
            props.defaults,
            props.fields,
            props.formId,
            props.onSubmit,
            props.schema
        ];
    },

    buildFormConfig(props = {}) {

        const {
            formId = FormConfig.formId,
            onSubmit,
            defaults = FormConfig.defaults.build(),
            fields = FormConfig.fields.build(),
            schema = internals.schema
        } = props;

        return {
            onSubmit,
            fields,
            defaults,
            formId,
            formOptions: {
                mode: 'onChange',
                criteriaMode: 'all'
            },
            schema,
            syncDefaults: false
        };
    },

    defaults: {
        build() {

            return internals.buildDefaults();
        }
    },

    fields: {
        build() {

            return internals.buildFields();
        }
    },

    submit: {
        buildPayload(data = {}, props = {}) {

            const {
                currentUserId
            } = props;
            const formattedData = {
                ...data,
                questions: FormConfig.submit.formatQuestions(data.questions || [])
            };

            return {
                questions: formattedData.questions,
                surveyId: formattedData.id,
                userId: currentUserId
            };
        },

        formatQuestion(question = {}) {

            const formattedQuestion = {
                ...question,
                selectedAnswer: question.selectedAnswer === 'null' ? null : question.selectedAnswer
            };

            if (question.answerType === 'checkbox') {
                formattedQuestion.checkboxAnswers = Array.isArray(question.checkboxAnswers) ? question.checkboxAnswers : [];
            }

            return formattedQuestion;
        },

        formatQuestions(questions = []) {

            return questions.map(FormConfig.submit.formatQuestion);
        }
    },

    schema: null
};

FormConfig.buildDefaults = FormConfig.defaults.build;
FormConfig.buildFields = FormConfig.fields.build;
FormConfig.buildSubmitPayload = FormConfig.submit.buildPayload;
FormConfig.formatQuestionForSubmission = FormConfig.submit.formatQuestion;
FormConfig.formatQuestionsForSubmission = FormConfig.submit.formatQuestions;

const internals = {};

internals.buildDefaults = () => ({
    id: '',
    title: '',
    description: '',
    questions: []
});

internals.buildFields = () => ([
    {
        name: 'id',
        type: 'custom',
        default: ''
    },
    {
        name: 'title',
        type: 'custom',
        default: ''
    },
    {
        name: 'description',
        type: 'custom',
        default: ''
    },
    {
        name: 'questions',
        type: 'custom',
        default: []
    }
]);

internals.schema = Joi.object({
    questions: Joi.array().items(
        Joi.object({
            selectedAnswer: Joi.when('answerType', {
                is: 'select',
                then: Joi.string().allow(null, '').optional(),
                otherwise: Joi.any().optional()
            }),

            checkboxAnswers: Joi.when('answerType', {
                is: 'checkbox',
                then: Joi.array().items(Joi.string()).optional(),
                otherwise: Joi.any().optional()
            }),

            freeInputAnswer: Joi.when('answerType', {
                is: 'freeInput',
                then: Joi.string().allow('').optional(),
                otherwise: Joi.any().optional()
            }),

            answerType: Joi.string().valid('freeInput', 'select', 'checkbox')
        }).unknown(true)
    )
}).unknown(true);

FormConfig.schema = internals.schema;
FormConfig.internals = internals;
